import React from "react";

const Divider = () => {
  return (
    <div className="mx-auto p-4 bg-white dark:bg-gray-900">
      <hr className="h-px my-8 bg-gray-200 border-0 dark:bg-gray-700" />
    </div>
  );
};

export default Divider;
